import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getAnalyticsPageContext } from '../../services/siteAnalytics';

const TMR_ID = '3750543';
const TMR_SCRIPT_ID = 'tmr-code';

declare global {
  interface Window {
    _tmr?: Array<Record<string, unknown>>;
    __yuzhenTmrLoaded?: boolean;
    __yuzhenTmrScheduled?: boolean;
  }
}

const ensureTopMailLoaded = () => {
  if (window.__yuzhenTmrLoaded || document.getElementById(TMR_SCRIPT_ID)) {
    return;
  }

  window._tmr = window._tmr || [];

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.id = TMR_SCRIPT_ID;
  script.src = 'https://top-fwz1.mail.ru/js/code.js';

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  window.__yuzhenTmrLoaded = true;
};

const scheduleTopMailLoad = () => {
  if (window.__yuzhenTmrLoaded || window.__yuzhenTmrScheduled) {
    return;
  }

  window.__yuzhenTmrScheduled = true;
  const idleWindow = window as Window &
    typeof globalThis & {
      requestIdleCallback?: (
        callback: IdleRequestCallback,
        options?: IdleRequestOptions
      ) => number;
    };

  const queueLoad = () => {
    if (typeof idleWindow.requestIdleCallback === 'function') {
      idleWindow.requestIdleCallback(() => ensureTopMailLoaded(), { timeout: 2500 });
      return;
    }

    window.setTimeout(() => ensureTopMailLoaded(), 1200);
  };

  if (document.readyState === 'complete') {
    queueLoad();
    return;
  }

  window.addEventListener(
    'load',
    () => {
      queueLoad();
    },
    { once: true }
  );
};

const TrackingConsentLoader: React.FC = () => {
  const location = useLocation();
  const lastTrackedPathRef = useRef('');

  useEffect(() => {
    scheduleTopMailLoad();
  }, []);

  useEffect(() => {
    const pageContext = getAnalyticsPageContext(`${location.pathname}${location.search || ''}`);
    if (pageContext.pagePath === lastTrackedPathRef.current) {
      return;
    }

    lastTrackedPathRef.current = pageContext.pagePath;
    window._tmr = window._tmr || [];
    window._tmr.push({
      id: TMR_ID,
      type: 'pageView',
      start: Date.now(),
    });
  }, [location.pathname, location.search]);

  return null;
};

export default TrackingConsentLoader;
